export enum PatientTypeData {
  ADDRESS = 'HOMEADDR',
  EMAIL = 'HOMEEMAIL',
  PHONE = 'CELLPHONE'
}
